<app-alias-header [alias]="selectedAlias"
                (filtersChanged)="onFilterChange($event)">
</app-alias-header>
<app-alias-table (selectedRow)="onCheckChange()" 
                (tableLoaded)="onTableLoaded($event)"
                [filters]="filters"
                class="col-12">
</app-alias-table>


